'use client';
import cx from 'clsx';
import React from 'react';
import { Box, getRadius, rem } from '@mantine/core';
import classes from '../flagpack.module.css.mjs';

function PRFlag({ radius, className, size, ...others }) {
  return /* @__PURE__ */ React.createElement(
    Box,
    {
      className: cx(classes.flag, className),
      __vars: { "--flag-radius": getRadius(radius), "--flag-size": rem(size) },
      ...others
    },
    /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 24" }, /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("mask", { id: "mantine-m6vrlluob", fill: "#fff" }, /* @__PURE__ */ React.createElement("path", { fillRule: "evenodd", d: "M0 0h32v24H0z" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-nniqyumk7", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-j6hfpdwu1" })), /* @__PURE__ */ React.createElement("mask", { id: "mantine-7cromdpj0", fill: "#fff" }, /* @__PURE__ */ React.createElement("use", { fillRule: "evenodd", xlinkHref: "#mantine-bxchp7kve" })), /* @__PURE__ */ React.createElement("path", { id: "mantine-j6hfpdwu1", d: "M0 0h32v24H0z" }), /* @__PURE__ */ React.createElement("path", { id: "mantine-bxchp7kve", d: "M0 0v24l18-12z" })), /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd", mask: "url(#mantine-m6vrlluob)" }, /* @__PURE__ */ React.createElement("use", { fill: "#ef0000", xlinkHref: "#mantine-j6hfpdwu1" }), /* @__PURE__ */ React.createElement(
      "path",
      {
        fill: "#ef0000",
        stroke: "#f7fcff",
        strokeWidth: "4",
        d: "M-2 8h36v8H-2z",
        mask: "url(#mantine-nniqyumk7)"
      }
    ), /* @__PURE__ */ React.createElement("use", { fill: "#3d58db", xlinkHref: "#mantine-bxchp7kve" }), /* @__PURE__ */ React.createElement("g", { fill: "#f7fcff", mask: "url(#mantine-7cromdpj0)" }, /* @__PURE__ */ React.createElement("path", { d: "M6.688 14.217l-3.672 1.938 1.788-3.894-2.278-2.08 2.812-.104 1.35-3.52 1.03 3.52h2.808l-1.872 2.184 1.489 3.894z" }))))
  );
}

export { PRFlag };
//# sourceMappingURL=PR.mjs.map
